// export default () => ({
// })

export default () => ({
    companies: [],
    companiesSelectable: [],
    companiesPaginatedData: null,
    company: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})